// True for K-ID partner sites (kid-prod, kid-pre-prod, kid-qa, k-id, …).
// Matches "kid" or "k-id" only as a standalone segment of the site name —
// a bare `includes("kid")` also matches sites like
// "GAVS-USA-BLINKID-AGEMATCH1" (the "kid" inside "blinkid"), which
// hijacked non-kid journeys into the kid-site capture flow. The same
// leading boundary keeps "blink-id" from matching the "k-id" form.
export const isKidSite = (siteName = "") =>
  /(^|[^a-z])(kid|k-id)([^a-z]|$)/.test(String(siteName).toLowerCase());

export default isKidSite;
